import { Image, NodeProps } from '../types';

type Props = Partial<NodeProps['Image']>;

export function image(): Image;
export function image(props: Props): Image;
export function image(...args: [] | [Props]): Image {
  return ['Image', args[0] ?? {}];
}
